import { FunctionComponent } from 'react'
import { Text } from '@conexasaude/conexa-hero'
import { useLocation } from 'react-router-dom'
import Modal from '@/components/Modal'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './styles'
import type { ConfirmPatientModalProps } from './types'

const ConfirmPatientModal: FunctionComponent<ConfirmPatientModalProps> = ({
  onConfirm,
  onNegativeAction,
  busy,
  modalId = 'CONFIRM_PATIENT',
}) => {
  const location = useLocation()
  const { logAnalyticsEvent } = useFirebaseContext()
  const { closeModal } = useModalContext()
  const styles = useStyles()

  const checkPathContains = (targetString: string) => {
    const currentPath = location?.pathname
    return currentPath?.includes(targetString)
  }

  const logoutAndRedirectWithAnalytics = () => {
    if (checkPathContains('sua-saude')) {
      logAnalyticsEvent('Pac_SuaSaude_EssaConsultaEParaVoceNao')
    }
    closeModal()
    onNegativeAction?.()
  }

  const handleConfirmWithAnalytics = async () => {
    if (checkPathContains('sua-saude')) {
      logAnalyticsEvent('Pac_SuaSaude_EssaConsultaEParaVoceSim')
    }

    await onConfirm?.()
  }

  const onDimissWithAnalytics = () => {
    if (checkPathContains('sua-saude')) {
      logAnalyticsEvent('Pac_SuaSaude_FecharModal')
    }
    closeModal()
  }

  return (
    <Modal
      id={modalId}
      onDismiss={onDimissWithAnalytics}
      primaryAction={handleConfirmWithAnalytics}
      primaryActionLabel="Confirmar"
      busyPrimaryAction={busy}
      negativeAction={logoutAndRedirectWithAnalytics}
      negativeActionLabel="Ver meus dependentes"
    >
      <div css={styles.contentWrapper}>
        <Text>
          Caso a consulta seja para um dependente, acesse o perfil a ser
          consultado.
        </Text>
      </div>
    </Modal>
  )
}

export { ConfirmPatientModal }
